import React from "react";
import { API_CONFIG } from "../../config/api";

const Pagination = ({
  page = 1,
  limit = API_CONFIG.PAGINATION.DEFAULT_LIMIT,
  total = 0,
  itemsCount = 0,
  onPageChange = () => {},
  onLimitChange = () => {},
  pageSizes = API_CONFIG.PAGINATION.PAGE_SIZES,
  loading = false,
}) => {
  const totalPages =
    total > 0
      ? Math.max(1, Math.ceil(total / limit))
      : Math.max(1, Math.ceil(itemsCount / limit));

  const handlePrev = () => {
    if (page > 1 && !loading) onPageChange(page - 1);
  };
  const handleNext = () => {
    if (!loading && page < totalPages) onPageChange(page + 1);
  };
  const handleLimitChange = (e) => {
    const newLimit =
      Number(e.target.value) || API_CONFIG.PAGINATION.DEFAULT_LIMIT;
    onLimitChange(newLimit);
  };

  if (itemsCount === 0 && total === 0) return null;

  const pageButtons = [];
  const maxButtons = 5;
  let start = Math.max(1, page - Math.floor(maxButtons / 2));
  let end = start + maxButtons - 1;
  if (end > totalPages) {
    end = totalPages;
    start = Math.max(1, end - maxButtons + 1);
  }
  for (let i = start; i <= end; i++) pageButtons.push(i);

  return (
    <div className="bw-pagination">
      <div className="d-flex align-items-center gap-1">
        <button
          className="btn btn-sm btn-outline-secondary"
          onClick={handlePrev}
          disabled={page === 1 || loading}
          title="Previous"
        >
          <i className="cil-chevron-left" />
        </button>

        <div className="d-flex align-items-center gap-1 bw-pages">
          {pageButtons.map((p) => (
            <button
              key={p}
              className={`btn btn-sm ${
                p === page ? "btn-primary" : "btn-outline-secondary"
              }`}
              onClick={() => onPageChange(p)}
              disabled={loading}
            >
              {p}
            </button>
          ))}
        </div>

        <button
          className="btn btn-sm btn-outline-secondary"
          onClick={handleNext}
          disabled={page >= totalPages || loading}
          title="Next"
        >
          <i className="cil-chevron-right" />
        </button>
      </div>

      <div
        className="small"
        style={{ color: "var(--bw-text-muted)", marginLeft: "0.5rem" }}
      >
        {total > 0 ? (
          <>
            Page <strong>{page}</strong> of <strong>{totalPages}</strong> —
            showing {itemsCount} of {total}
          </>
        ) : (
          <>
            Page <strong>{page}</strong> — showing {itemsCount}
          </>
        )}
      </div>

      <div className="ms-auto d-flex align-items-center gap-2">
        <label
          className="m-0 small"
          style={{ color: "var(--bw-text-muted)", fontWeight: 600 }}
        >
          Rows
        </label>
        <select
          className="form-select form-select-sm"
          value={limit}
          onChange={handleLimitChange}
          style={{ width: 78 }}
        >
          {pageSizes.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default Pagination;
